'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

var _videoModal = require('../../../organisms/video-modal');

var _videoModal2 = _interopRequireDefault(_videoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPMediaButton = function (_React$Component) {
  _inherits(MPPMediaButton, _React$Component);

  function MPPMediaButton(props) {
    _classCallCheck(this, MPPMediaButton);

    var _this = _possibleConstructorReturn(this, (MPPMediaButton.__proto__ || Object.getPrototypeOf(MPPMediaButton)).call(this, props));

    _this.componentDidMount = function () {
      _this.setBodyRef();
    };

    _this.setBodyRef = function () {
      /*
      * This method is used to find the closest BODY parent to MPPMediaButton
      * and is needed since we need to pass the correct body DOM element into
      * MPPVideoModal and MPPModal to be appended to.
      * This will work in every browser, as well as in iframes
      */
      var currentRef = _this.buttonRef && _this.buttonRef.parentNode;
      while (!_this.bodyRef && currentRef) {
        if (currentRef.tagName === 'BODY') {
          _this.bodyRef = currentRef;
        } else {
          currentRef = currentRef.parentNode;
        }
      }
      _this.bodyRef = _this.bodyRef || document.body;
      _this.forceUpdate();
    };

    _this.openModal = function (e) {
      e.preventDefault();
      _this.setState({
        showModal: true
      });
    };

    _this.closeModal = function () {
      _this.setState({
        showModal: false
      });
    };

    _this.renderVideoModal = function (videoId) {
      if (videoId) {
        return _react2.default.createElement(_videoModal2.default, {
          bodyRef: _this.bodyRef,
          show: _this.state.showModal,
          videoId: videoId,
          closeModal: _this.closeModal
        });
      }
      return null;
    };

    _this.state = {
      showModal: false
    };
    _this.bodyRef = undefined;
    _this.buttonRef = null;
    return _this;
  }

  _createClass(MPPMediaButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var videoId = this.props['data-video-id'];

      var _props = this.props,
          fpti = _props.fpti,
          rest = _objectWithoutProperties(_props, ['fpti']);

      var classes = (0, _classnames2.default)('mpp-media-btn', this.props.className);

      // if videoId is NOT passed do not create the button
      if (!videoId) return null;

      /*
        NOTE: Do not use React.Fragment since refs can not be assigned
        to pure function components. Hence the need to wrap using a div
        SEE: https://github.paypal.com/MPPContentDevelopment/marketing-components/pull/152
      */
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(element) {
            _this2.buttonRef = element;
          }
        },
        _react2.default.createElement(
          _button2.default,
          _extends({}, rest, {
            className: classes,
            fpti: fpti,
            onClick: this.openModal
          }),
          _react2.default.createElement('span', { className: 'mpp-media-btn__icon' }),
          _react2.default.createElement(
            'span',
            { className: 'mpp-media-btn__content' },
            this.props.children
          )
        ),
        this.renderVideoModal(videoId)
      );
    }
  }]);

  return MPPMediaButton;
}(_react2.default.Component);

exports.default = MPPMediaButton;


MPPMediaButton.defaultProps = {
  className: '',
  color: 'outline-white',
  fpti: ''
};

MPPMediaButton.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  color: _propTypes2.default.oneOf(['outline-white', 'outline-blue']),
  fpti: _propTypes2.default.string,
  'data-video-id': _propTypes2.default.string.isRequired
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/atoms/media-button/jsx/MPPMediaButton.js
// module id = 411
// module chunks = 4